import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { environments } from '@/environment';
import { BootService } from '@/services/boot';
import { useOrder } from '@/hooks/order';
import { UpdateOrderDeliveryHomeModal } from '@/types/modal';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore NOTHING I CAN DO
import { AddressForm } from '@vestiaire/vc-address-form';
import { AddressFormModal, ErrorModal } from '@/components/molecules/common/Modal';

const View: React.FC<{ modal: UpdateOrderDeliveryHomeModal }> = ({ modal }) => {
  const { t } = useTranslation();
  const { onClose, order } = modal;
  const orderR = useOrder(Number(order.orderId), false);
  const [isError, setIsError] = useState(false);

  const path = '/adser/order';
  const adserProps = {
    context: 'OrderDeliveryAddress',
    modalOpen: false,
    screen: 'default',
    editAddress: {
      clientId: order.buyerId,
      country: order.orderCountry,
      id: Number(order.orderId),
    },
  };

  useEffect(() => {
    const errorListener = () => {
      setIsError(true);
    };
    const closeListener = () => {
      onClose();
    };
    const addNewAddressListener = () => {
      orderR.refetch();
      onClose();
    };
    const selectAddressListener = () => {
      orderR.refetch();
      onClose();
    };

    window.removeEventListener('add-new-address', addNewAddressListener);
    window.removeEventListener('closeAdserModal', closeListener);
    window.removeEventListener('adserError', errorListener);
    window.addEventListener('add-new-address', addNewAddressListener);
    window.addEventListener('closeAdserModal', closeListener);
    window.addEventListener('adserError', errorListener);

    return () => {
      window.removeEventListener('add-new-address', addNewAddressListener);
      window.removeEventListener('select-address', selectAddressListener);
      window.removeEventListener('closeAdserModal', closeListener);
      window.removeEventListener('adserError', errorListener);
    };
  }, []);

  try {
    if (isError) {
      return (
        <ErrorModal
          title={t('address_form.title')}
          message={t('service_error.access_denied')}
          onClose={onClose}
          containerStyle={{ minWidth: 400 }}
        />
      );
    }
    return (
      <AddressFormModal
        body={
          <AddressForm
            wcconfig={{
              env: BootService.env,
              lang: 'en',
              parentTool: {
                name: 'C360',
                baseURL: environments[BootService.env].cstBaseUrl + path,
                headers: BootService.getHeaders(),
              },
            }}
            props={adserProps}
          />
        }
        onClose={onClose}
      />
    );
  } catch (error) {
    return (
      <ErrorModal
        title={t('address_form.title')}
        message={t('service_error.general')}
        onClose={onClose}
        containerStyle={{ minWidth: 400 }}
      />
    );
  }
};

export default View;
